import { ApiClient } from "../ApiClient";

/**
 * Create expert demo filings for CPA users
 * @param {Array} demoServices - Array of demo service objects
 * Example: [{ service: "PTF", invitation_code: "ABC123" }, { service: "BTF" }]
 * @returns {Promise<Response>}
 */
export const createExpertDemoFilings = async (demoServices) => {
  // ApiClient.post handles baseUrl, CSRF, JSON stringification, and 401 interception
  return ApiClient.post("/tax/expert-demo-filing", {
    demo_services: demoServices,
  });
};
